const Pokedex = require("pokeapi-js-wrapper");

export const P = new Pokedex.Pokedex();
